/**
 * TimeEditLockSettings — Global Edit-Lock Stunden Einstellung (Admin)
 */
import { useEffect, useState } from "react";
import { authFetch } from "../App";
import { toast } from "sonner";
import { Timer, Save, Loader2 } from "lucide-react";

const API = "/api";

export default function TimeEditLockSettings() {
  const [hours, setHours] = useState(12);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await authFetch(`${API}/settings/time-edit-lock`);
        if (r.ok) {
          const d = await r.json();
          setHours(d.hours || 12);
        }
      } catch {}
      setLoading(false);
    })();
  }, []);

  const save = async () => {
    const v = Math.max(1, Math.min(720, parseInt(hours, 10) || 12));
    setSaving(true);
    try {
      const r = await authFetch(`${API}/settings/time-edit-lock`, {
        method: "PUT", body: JSON.stringify({ hours: v }),
      });
      if (r.ok) {
        toast.success(`Bearbeitungsfenster auf ${v}h gesetzt`);
        setHours(v);
      } else {
        const e = await r.json().catch(() => ({}));
        toast.error(e.detail || "Speichern fehlgeschlagen");
      }
    } catch {
      toast.error("Netzwerkfehler");
    }
    setSaving(false);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-testid="time-edit-lock-settings">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 bg-amber-50 rounded-lg flex items-center justify-center shrink-0">
          <Timer className="w-5 h-5 text-amber-600" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-gray-900">Bearbeitungs-Fenster (Stundenzettel)</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            Wie viele Stunden nach Eingabe darf ein Mitarbeiter seinen Stundenzettel ändern? Pro Mitarbeiter individuell überschreibbar.
          </p>
        </div>
      </div>
      {loading ? (
        <div className="flex justify-center py-4"><Loader2 className="w-4 h-4 animate-spin text-gray-400" /></div>
      ) : (
        <div className="flex items-end gap-3">
          <div className="flex-1 max-w-[180px]">
            <label className="text-xs text-gray-500 mb-1 block">Globaler Standard</label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                min="1"
                max="720"
                value={hours}
                onChange={(e) => setHours(e.target.value)}
                className="w-24 h-10 px-3 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-sm"
                data-testid="global-edit-lock-input"
              />
              <span className="text-sm text-gray-600">Stunden</span>
            </div>
          </div>
          <button
            type="button"
            onClick={save}
            disabled={saving}
            className="h-10 px-4 bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white rounded-lg text-sm font-semibold flex items-center gap-1.5"
            data-testid="save-global-edit-lock-btn"
          >
            {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />}
            Speichern
          </button>
        </div>
      )}
      <div className="mt-3 text-[11px] text-gray-400">
        Empfehlung: 12-24 Stunden. Max 720 (= 30 Tage).
      </div>
    </div>
  );
}
